import { useState } from "react";
import type { StaffDivideItem } from "../../types";

const BRAND = "#FF6B35";

interface Props {
  item: StaffDivideItem;
}

export function DivideItem({ item }: Props) {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="bg-white rounded-2xl p-4 space-y-3">
      {/* 第一行：名称 + 收益 */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold text-gray-900">{item.item_name}</span>
        <div className="flex items-center gap-1 font-bold text-red-500 text-base">
          + ¥{item.earnings}
        </div>
      </div>

      {/* 第二行：订单号 + 展开 */}
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">订单号: {item.ordersn}</span>
        <button
          onClick={() => setShowMore(!showMore)}
          className="text-xs flex items-center gap-0.5 font-medium active:opacity-70"
          style={{ color: BRAND }}
        >
          {showMore ? "收起" : "查看更多"}
          <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${showMore ? "rotate-180" : ""}`} />
        </button>
      </div>

      {/* 服务时间 */}
      <p className="text-xs text-gray-400">服务时间: {item.book_time}</p>

      {/* 展开详情 */}
      {showMore && (
        <div className="pt-3 border-t border-gray-50 space-y-2">
          {[
            { label: "项目总金额", value: item.item_price },
            { label: "项目收益", value: item.item_cost },
          ].map((row) => (
            <div key={row.label} className="flex items-center justify-between text-xs">
              <span className="text-gray-500">{row.label}</span>
              <span className="font-medium text-gray-800">¥{row.value}</span>
            </div>
          ))}
          {parseFloat(String(item.reward_price ?? 0)) > 0 && (
            <div className="flex items-center justify-between text-xs">
              <span className="text-gray-500">打赏收益</span>
              <span className="font-medium" style={{ color: BRAND }}>¥{item.reward_price}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
